module.exports = __webpack_public_path__ + "img/cdBackground.c6e9c65a.png";